import { KendoBaseComponent, KendoBaseDatasourceComponent, KendoSharedMethods } from '@progress/kendo-base-components-vue-wrapper'
import MenuProps from './MenuProps'

import OpenOnClick from './OpenOnClick'
import Animation from '../Common/Animation'
import Scrollable from '../Common/Scrollable'

export default {
    props: MenuProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        KendoSharedMethods,
        Animation,
        OpenOnClick,
        Scrollable
    ],
    mounted() {
        this._resolveChildren()

        kendo.jQuery(this.$el).kendoMenu(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoMenu()
        },
        _resolveChildren() {
            const defaultSlot = (this.v3 && this.$slots.default && (typeof this.$slots.default === 'function')) ? this.$slots.default() : this.$slots.default
            const hasDataSource = this.v3 ? (!this.$props.dataSource) : (this.$options.propsData && !this.$options.propsData['dataSource'])
            if(hasDataSource && defaultSlot){
                var items = this.resolveInnerTags('kendo-menu-item')

                if(items.length) {
                    this.widgetOptions['dataSource'] = items
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoMenu/KendoMenuMixin.js